import axios from 'axios';

export default {
  state: {
    products: [],
    section_id: false,
    product_total: 0,
    section: {},
    loading: false,
    error: null,
    productsLoaded: false,
    noMoreProducts: false,
    lastFetchProductsKey: null
  },
  mutations: {
    SET_PRODUCTS(state, {products, page}) {
      if (page > 1) {
        state.products = state.products.concat(products.data.items)
      }
      else
        state.products = products.data.items;
      if (state.products.length >= products.data.total)
        state.noMoreProducts = true;
      state.productsLoaded = true; // Устанавливаем флаг, что данные загружены
      state.section = products.data.section;
      state.product_total = products.data.total;
    },
    SET_PRODUCTS_LOADING(state, status) {
      state.productsLoading = status;
    },
    SET_PRODUCTS_ERROR(state, error) {
      state.productsError = error;
    },
    UNSET_PRODUCTS(state) {
      state.productsLoaded = false;
      state.productsLoading = false;
      state.products = [];
      state.product_total = 0;
      state.section = {};
      state.noMoreProducts = false;
    },
    SET_LAST_FETCH_PRODUCTS_KEY(state, key) {
      state.lastFetchProductsKey = key;
    },
  },
  actions: {
    async fetchProducts({ commit, state, rootState }, {id, page, sort, filter={}, search='', first=false}) {

      if (id == undefined)
        return;

      // Нормализуем filter (порядок ключей/элементов не влияет) и собираем "сигнатуру" запроса
      const stableSerialize = (value) => {
        if (Array.isArray(value)) {
          // Если в массиве объекты — сортируем по их стабильной сериализации
          return value
            .map(stableSerialize)
            .sort();
        }
        if (value && typeof value === 'object') {
          const keys = Object.keys(value).sort();
          const out = {};
          for (let i = 0; i < keys.length; i++) {
            const k = keys[i];
            out[k] = stableSerialize(value[k]);
          }
          return out;
        }
        return value;
      };

      const requestKey = JSON.stringify({
        id: id,
        //page: page,
        sort: sort,
        q: search,
        gender: _.get(rootState, 'gender.gender'),
        filter: stableSerialize(filter)
      });

      // Если повторный вызов с теми же параметрами — ничего не делаем
      if (state.products.length > 0 && state.lastFetchProductsKey === requestKey && first) {
        return;
      }

      commit('SET_LAST_FETCH_PRODUCTS_KEY', requestKey);

      if (state.products.length > 0 && state.section_id == id && first) {
        //return;
      }

      state.section_id = id;

      if (page == 1)
      commit('UNSET_PRODUCTS');


      try {
        commit('SET_PRODUCTS_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/elements/'+id+'/', {
          params: {
            page: page,
            filter: filter,
            sort: sort,
            q: search,
            gender: rootState.gender.gender
          }
        });
        if (response.data.status != 'success') {
          commit('UNSET_PRODUCTS');
          commit('SET_PRODUCTS_ERROR', 'Ошибка при загрузке.');
        }
        else {
          commit('SET_PRODUCTS', {products: response.data, page: page});
          commit('SET_PRODUCTS_ERROR', null);
        }
      } catch (error) {
        commit('SET_PRODUCTS_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching products:', error);
      } finally {
        commit('SET_PRODUCTS_LOADING', false);
      }
    }
  },
  getters: {
    products: state => state.products,
    product_total: state => state.product_total,
    section: state => state.section,
    productsLoading: state => state.productsLoading,
    productsError: state => state.productsError,
    productsLoaded: state => state.productsLoaded,
    noMoreProducts: state => state.noMoreProducts
  }
}